module.exports = __webpack_public_path__ + "img/charme_white_ba_detail_rsh.ba0c520f.jpg";